import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermsValue } from '../../../packages/JsonQuery';
import { EBuildingHeatingType } from '../../../packages/api-models/common/json_query';

export const selectBuildingHeatingType = createSelector(
  selectJsonQuery,
  jsonQuery => getTermsValue('building_heating_type')(jsonQuery) as EBuildingHeatingType[] | null,
);
